// document.addEventListener("DOMContentLoaded", () => {
//   const headerWrapper = document.querySelector(".header-wrapper");
//   const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");

//   if (!headerWrapper) return;

//   headerWrapper.addEventListener("click", () => {
//     headerWrapper.classList.add("menu-active,color-scheme-1");
//   });

//   menuItems.forEach(item => {
//     const megaMenu = item.querySelector(".mega-menu__content");

//     if (!megaMenu) return;

//     // Show on hover
//     item.addEventListener("mouseenter", () => {
//       megaMenu.classList.add("mega-menu--open");
//       headerWrapper.classList.add("menu-active");
//     });

//     // Hide on out
//     item.addEventListener("mouseleave", () => {
//       megaMenu.classList.remove("mega-menu--open");
//       headerWrapper.classList.remove("menu-active");
//     });
//   });
// });
// document.addEventListener("click", function(e){

//   const nextBtn = e.target.closest(".slider-button--next");
//   const prevBtn = e.target.closest(".slider-button--prev");

//   if(!nextBtn && !prevBtn) return;

//   const slider = e.target.closest("media-gallery")?.querySelector(".quickadd-gallery");
//   if(!slider) return;

//   const slideWidth = slider.querySelector(".product__media-item")?.offsetWidth || 300;

//   if(nextBtn){
//     slider.scrollBy({
//       left: slideWidth,
//       behavior: "smooth"
//     });
//   }

//   if(prevBtn){
//     slider.scrollBy({
//       left: -slideWidth,
//       behavior: "smooth"
//     });
//   }

// });

document.addEventListener("DOMContentLoaded", function () {
  
  const textarea = document.getElementById("ContactForm-body");

  if (!textarea) return;

  const autoResize = () => {
    if (textarea.value.trim() === "") {
      textarea.style.height = "53px"; // reset when empty
    } else {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  };

  // Run on load (important)
  autoResize();

  // Run on input
  textarea.addEventListener("input", autoResize);
});


document.addEventListener('DOMContentLoaded', function () {

  const desktopSmall = document.querySelector('.grid-small');
  const desktopLarge = document.querySelector('.grid-large');

  const mobileSmall = document.querySelector('.grid-small-mobile');
  const mobileLarge = document.querySelector('.grid-large-mobile');

  function changeGrid(cols, activeButtons) {
    const productGrid = document.querySelector('#product-grid');

    if (!productGrid) return;

    // Remove existing classes
    productGrid.className = productGrid.className
      .replace(/grid--\d+-col-desktop/g, '')
      .replace(/grid--\d+-col-tablet-down/g, '');

    // Desktop
    if (window.innerWidth > 749) {
      productGrid.classList.add(`grid--${cols}-col-desktop`);
    }
    // Mobile
    else {
      productGrid.classList.add(`grid--${cols}-col-tablet-down`);
    }

    // Remove active class from all buttons
    [
      desktopSmall,
      desktopLarge,
      mobileSmall,
      mobileLarge
    ].forEach(btn => btn?.classList.remove('active'));

    // Add active class
    activeButtons.forEach(btn => btn?.classList.add('active'));
  }

  // Desktop
  desktopSmall?.addEventListener('click', function () {
    changeGrid(4, [desktopSmall]);
  });

  desktopLarge?.addEventListener('click', function () {
    changeGrid(6, [desktopLarge]);
  });

  // Mobile
  mobileSmall?.addEventListener('click', function () {
    changeGrid(1, [mobileSmall]); // 1 column mobile
  });

  mobileLarge?.addEventListener('click', function () {
    changeGrid(2, [mobileLarge]); // 2 columns mobile
  });

  // Default state
  if (window.innerWidth > 749) {
    desktopLarge?.classList.add('active');
  } else {
    mobileLarge?.classList.add('active');
  }

});


///////////////////Product-grid-wishlist-icon////////////////
(function () {
  'use strict';

  const wishlistSelector =
    '.wishlisthero-floating.wishlist-hero-custom-button button';

  function updateWishlistButton(button) {
    if (!button || !button.matches(wishlistSelector)) {
      return;
    }

    const svg = button.querySelector('svg');

    if (!svg) {
      return;
    }

    const isAdded =
      button.classList.contains('wishlisthero-product-in-wishlist');

    const requiredState = isAdded ? 'filled' : 'empty';
    if (
      svg.getAttribute('data-custom-wishlist-state') === requiredState
    ) {
      return;
    }

    const template = document.getElementById(
      isAdded
        ? 'wishlist-icon-filled'
        : 'wishlist-icon-empty'
    );

    if (
      !template ||
      !template.content.firstElementChild
    ) {
      return;
    }

    const newIcon =
      template.content.firstElementChild.cloneNode(true);

    newIcon.setAttribute(
      'data-custom-wishlist-state',
      requiredState
    );

    newIcon.style.width = '25px';
    newIcon.style.height = '25px';
    newIcon.style.display = 'inline-block';

    svg.replaceWith(newIcon);
  }


  function updateAllWishlistButtons() {
    document
      .querySelectorAll(wishlistSelector)
      .forEach(function (button) {
        updateWishlistButton(button);
      });
  }


  function init() {
    updateAllWishlistButtons();


    const observer = new MutationObserver(function (mutations) {

      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {

          const button = mutation.target.closest
            ? mutation.target.closest(wishlistSelector)
            : null;

          if (button) {
            updateWishlistButton(button);
          }

          return;
        }

        if (mutation.type === 'childList') {

          mutation.addedNodes.forEach(function (node) {

            if (node.nodeType !== 1) {
              return;
            }
            if (
              node.matches &&
              node.matches(wishlistSelector)
            ) {
              updateWishlistButton(node);
            }
            if (node.querySelectorAll) {

              node
                .querySelectorAll(wishlistSelector)
                .forEach(function (button) {
                  updateWishlistButton(button);
                });

            }

          });

        }

      });

    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'aria-label',
        'class'
      ]
    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();




document.addEventListener('DOMContentLoaded', function () {

    function updateWishlistHeading() {

        // Check if Wishlist Hero page exists
        const wishlistPage = document.querySelector(
            '#wishlist-hero-shared-list-view'
        );

        if (!wishlistPage) {
            return false;
        }

        // Find heading only inside Wishlist page
        const heading = wishlistPage.querySelector(
            '.wishlist-hero-page-header'
        );

        if (!heading) {
            return false;
        }


        /* =========================
           REPLACE HEART SVG
        ========================== */

        const oldSvg = heading.querySelector('svg');

        if (oldSvg && !heading.querySelector('.icon-wishlist')) {

            const svgWrapper = document.createElement('div');

            svgWrapper.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="29.875"
                     height="29.389"
                     viewBox="0 0 29.875 29.389"
                     class="icon-wishlist">

                    <defs>
                        <clipPath id="clip-path">
                            <rect
                                id="Rectangle_84"
                                data-name="Rectangle 84"
                                width="25.031"
                                height="24.384"
                                transform="translate(0 0)"
                                fill="#ff5757">
                            </rect>
                        </clipPath>
                    </defs>

                    <g
                        id="Group_69"
                        data-name="Group 69"
                        transform="translate(0 5.631) rotate(-13)">

                        <g
                            id="Group_68"
                            data-name="Group 68"
                            transform="translate(0)"
                            clip-path="url(#clip-path)">

                            <path
                                id="Path_36"
                                data-name="Path 36"
                                d="M11.713,7.531c-.826-1.467-1.458-2.8-2.288-4.007A11,11,0,0,0,7.032.866a3.97,3.97,0,0,0-5.96,1.191A8.027,8.027,0,0,0,.035,6.9,24.817,24.817,0,0,0,5.044,20.584c.249.312.49.633.756.931,2.783,3.179,6.468,3.634,9.987,1.123a23.161,23.161,0,0,0,8.507-11.525c1.414-4.071-2.256-7.538-6.8-6.474a22.911,22.911,0,0,0-4.361,1.9,10.529,10.529,0,0,0-1.421.988"
                                transform="translate(0.102 0.021)"
                                fill="#ff5757">
                            </path>

                        </g>
                    </g>
                </svg>
            `;

            const newSvg = svgWrapper.querySelector('svg');

            oldSvg.replaceWith(newSvg);
        }


        /* =========================
           WRAP HEADING TEXT
        ========================== */

        if (!heading.querySelector('.wishlist-heading-text')) {

            Array.from(heading.childNodes).forEach(function (node) {

                if (
                    node.nodeType === Node.TEXT_NODE &&
                    node.textContent.trim() !== ''
                ) {

                    const span = document.createElement('span');

                    span.className = 'wishlist-heading-text';
                    span.textContent = node.textContent.trim();

                    span.style.setProperty(
                        'font-family',
                        'var(--font-heading-family)',
                        'important'
                    );

                    node.replaceWith(span);
                }

            });

        }


        // Confirm both changes completed
        if (
            heading.querySelector('.icon-wishlist') &&
            heading.querySelector('.wishlist-heading-text')
        ) {
            return true;
        }

        return false;
    }


    // Wishlist Hero loads dynamically
    const checkWishlist = setInterval(function () {

        if (updateWishlistHeading()) {
            clearInterval(checkWishlist);
        }

    }, 500);


    // Stop after 30 seconds
    setTimeout(function () {
        clearInterval(checkWishlist);
    }, 30000);

});




document.addEventListener('DOMContentLoaded', function () {

    let isDown = false;
    let activeCarousel = null;
    let startX = 0;
    let scrollLeft = 0;
    let hasDragged = false;


    // MOUSE DOWN
    document.addEventListener('mousedown', function(e) {

        const carousel = e.target.closest(
            '.cart-drawer__cross-sell-carousel'
        );

        if (!carousel) return;

        // Only left mouse button
        if (e.button !== 0) return;

        isDown = true;
        hasDragged = false;
        activeCarousel = carousel;

        startX = e.pageX;
        scrollLeft = carousel.scrollLeft;

        carousel.classList.add('is-dragging');

    });


    // MOUSE MOVE
    document.addEventListener('mousemove', function(e) {

        if (!isDown || !activeCarousel) return;

        const x = e.pageX;

        const distance = x - startX;

        // Consider it drag after 5px
        if (Math.abs(distance) > 5) {
            hasDragged = true;
        }

        activeCarousel.scrollLeft =
            scrollLeft - distance;

    });


    // MOUSE UP
    document.addEventListener('mouseup', function() {

        if (!activeCarousel) return;

        activeCarousel.classList.remove('is-dragging');

        isDown = false;

        setTimeout(function() {
            activeCarousel = null;
            hasDragged = false;
        }, 0);

    });


    // Mouse leaves browser/window
    window.addEventListener('blur', function() {

        if (activeCarousel) {
            activeCarousel.classList.remove('is-dragging');
        }

        isDown = false;
        activeCarousel = null;
        hasDragged = false;

    });


    /*
     * Prevent product link/button click
     * when user was dragging
     */
    document.addEventListener('click', function(e) {

        if (
            hasDragged &&
            e.target.closest('.cart-drawer__cross-sell-carousel')
        ) {
            e.preventDefault();
            e.stopPropagation();
        }

    }, true);

});
